import React, { useEffect, useState, memo } from "react";
import "react-edit-text/dist/index.css";
import Correct from "../../../../assets/icons/correct";
import { EditText, EditTextarea } from "react-edit-text";
import SingleAnswer from "./singleAnswer";

function Answers({ answers, style }) {

  const [totalCorrectAnswers, setTotalCorrectAnswers] = useState(0)

  useEffect(() => {
    let num = 0
    answers.map(ans => {
      if (ans.is_correct === true) {
        num += 1
      }
    })
    setTotalCorrectAnswers(num)
  }, [answers])

  return (
    <div className="answers row" style={style !== undefined ? { ...style.answers } : {}}>
      {answers.map((answer) => {
        return <SingleAnswer key={answer.id} style={style} answer={answer} totalCorrectAnswers={totalCorrectAnswers} />;
      })}
    </div>
  );
}

export default memo(Answers)
